import { request, withQuery } from './client';
import type { DocNote, DocNoteTarget } from '@kassa/shared';

// Sənəd qeydləri (KT-76)
export const notesApi = {
  notes: (target: DocNoteTarget) => request<DocNote[]>('GET', withQuery('/api/notes', { ...target })),
  noteAdd: (target: DocNoteTarget, body: string) => request<DocNote>('POST', '/api/notes', { ...target, body }),
};
